export const TABLE = {
  table: {
    ellipsis: '...',
    columns: 'Columns',
    search: 'Search',
    searchFields: 'Searchable Fields',
    columnsMenu: {
      pinLeft: 'Pin Left',
      pinRight: 'Pin Right',
      unpin: 'Unpin',
      hide: 'Hide',
      show: 'Show',
      left: 'Left',
      right: 'Right',
    },
    pagination: {
      firstPage: 'First Page',
      previousPage: 'Previous Page',
      nextPage: 'Next Page',
      lastPage: 'Last Page',
      noPages: 'No Pages',
    },
  },
}
